import { KrakendCollection, PagedResults } from "../models/generics";
import { LoaderMetadata, MetaLoaderListDTO, Rag, RagConfigs, RagListDTO, RagLoader } from "../models/LLM";
import client from "./axios";

const llmGatewayUrl = `${window.__env.KRAKEND_URL}/v1/llm`;

interface LoaderTestInfo {
  name: string;
  config: Record<string, any>;
}

interface TestLoaderResponse {
  is_working: boolean;
  error: string;
}

interface InvokeBody {
  context: Record<string, any>;
  input: { question: string };
  thread_id: string;
}

interface InvokeReponse {
  question: string;
  answer: {
    id: string,
    content: string,
    type: string,
  }
}

interface EmbedBody {
  id: string;
  loaderId: string;
  context: Record<string, any>;
  loader: LoaderTestInfo;
  splittingConf: any;
}

export const Llm = {
  getModels: () => client.get(`${llmGatewayUrl}/ollama/models`),
  pullModels: (model: any) => client.post(`${llmGatewayUrl}/ollama/pull-model`, model),
  getRagsContextConfigs: () => client.get<RagConfigs>(`${llmGatewayUrl}/rags/context-configs`),
  getRags: (params?: URLSearchParams) => client.get<PagedResults<RagListDTO> | KrakendCollection<RagListDTO>>(`${llmGatewayUrl}/rags`, { params }),
  getRag: (id: string) => client.get<Rag>(`${llmGatewayUrl}/rags/${id}`),
  createRag: (rag: RagListDTO) => client.post<RagListDTO>(`${llmGatewayUrl}/rags`, rag),
  editRag: (rag: RagListDTO) => client.put<RagListDTO>(`${llmGatewayUrl}/rags/${rag.id}`, rag),
  updateRagContext: (id: string, context: Record<string, any>) => client.put<Rag>(`${llmGatewayUrl}/rags/${id}/context`, context),
  deleteRag: (id: string) => client.delete(`${llmGatewayUrl}/rags/${id}`),
  invokeRag: (id: string, body: InvokeBody) => client.post<InvokeReponse>(`${llmGatewayUrl}/rags/${id}/invoke`, body),
  embedRagLoader: (body: EmbedBody) => client.post(`${llmGatewayUrl}/rags/${body.id}/embed`, body),
  getLoaders: (params?: URLSearchParams) => client.get<PagedResults<RagLoader> | KrakendCollection<RagLoader>>(`${llmGatewayUrl}/loaders`, { params }),
  getLoader: (id: string) => client.get<RagLoader>(`${llmGatewayUrl}/loaders/${id}`),
  createLoader: (loader: RagLoader) => client.post<RagLoader>(`${llmGatewayUrl}/loaders`, loader),
  editLoader: (loader: RagLoader) => client.put<RagLoader>(`${llmGatewayUrl}/loaders/${loader.id}`, loader),
  deleteLoader: (id: string) => client.delete(`${llmGatewayUrl}/loaders/${id}`),
  getLoadersDocumentation: () => client.get<MetaLoaderListDTO[]>(`${llmGatewayUrl}/loaders/documentation`),
  getLoaderDocumentation: (id: string) => client.get<LoaderMetadata>(`${llmGatewayUrl}/loaders/${id}/documentation`),
  testLoader: (loader: LoaderTestInfo) => client.post<TestLoaderResponse>(`${llmGatewayUrl}/loaders/test`, loader)
}